// Reduces `array` into an object using `iteratorFunc` that returns an object.
export default function reduceToObj(array, iteratorFunc) {
  return array.reduce(
    (obj, key, index) => Object.assign(obj, iteratorFunc(key, index)),
    {}
  );
}
